/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Config } from './app/core/models/config.model';
import { APP_CONFIG } from './app/app.tokens';

fetch('./config.json')
  .then(res => res.json())
  .then((config: Config) => {
    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }]);
    bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
  });

// fetch('./config.json')
//   .then(res => res.json())
//   .then((config: Config) => {
//     console.log('appConfig.providers:', appConfig.providers);
//     console.log('config:', config);
//     platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }]);
//     bootstrapApplication(AppComponent, {
//       ...config,
//       providers: [
//         ...(Array.isArray(appConfig.providers) ? appConfig.providers : []),
//         { provide: APP_CONFIG, useValue: config }
//       ]

//     }
//   ).catch(err => console.error(err));
//   });
